import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskRevealInView } from "../components/Reveal";
import { Marquee } from "../components/Marquee";
import { SERVICES } from "../data";

export default function Services() {
  return (
    <>
      <section className="pt-36 md:pt-48 pb-16">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
          <Reveal>
            <p className="font-sans text-[11px] tracking-[0.4em] uppercase text-rosedeep mb-10">
              Services — How I can help
            </p>
          </Reveal>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-8xl leading-[0.98] text-ink tracking-tight max-w-4xl">
            <MaskRevealInView lines={["Strategy, content"]} />
            <span className="italic font-display text-rosedeep">
              <MaskRevealInView lines={["and community — considered."]} delay={0.2} />
            </span>
          </h1>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 pb-24 md:pb-32">
        <div className="border-t border-borderwarm">
          {SERVICES.map((s, i) => (
            <Reveal key={s.n} delay={(i % 2) * 0.04}>
              <div className="group grid md:grid-cols-12 gap-6 py-9 md:py-11 border-b border-borderwarm items-baseline transition-colors duration-500 hover:bg-mutewarm">
                <div className="md:col-span-1">
                  <span className="font-sans text-[11px] tracking-[0.2em] text-rosedeep">{s.n}</span>
                </div>
                <h2 className="md:col-span-5 font-serif text-3xl md:text-5xl leading-tight text-ink transition-transform duration-500 md:group-hover:translate-x-2">
                  {s.title}
                </h2>
                <p className="md:col-span-5 font-sans text-base leading-relaxed text-mutedfg max-w-lg">
                  {s.desc}
                </p>
                <div className="md:col-span-1 flex md:justify-end">
                  <ArrowUpRight size={22} className="text-rose transition-all duration-500 group-hover:text-rosedeep group-hover:translate-x-1 group-hover:-translate-y-1" />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <div className="border-y border-borderwarm text-ink">
        <Marquee items={["Strategy", "Content", "Community", "Brand", "Partnerships"]} />
      </div>

      <section className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-24 md:py-32 text-center">
        <Reveal>
          <h2 className="font-serif text-4xl md:text-6xl text-ink leading-tight max-w-3xl mx-auto text-balance">
            Not sure where to start? Let's find the right fit together.
          </h2>
          <Link
            to="/contact"
            data-testid="services-cta"
            className="group inline-flex items-center gap-3 mt-10 rounded-full bg-rosedeep text-white px-8 py-4 font-sans text-[12px] tracking-[0.16em] uppercase transition-colors duration-300 hover:bg-ink"
          >
            Work With Me
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </Link>
        </Reveal>
      </section>
    </>
  );
}
